/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface OwnUserPasswordUpdateDto
 */
export interface OwnUserPasswordUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof OwnUserPasswordUpdateDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OwnUserPasswordUpdateDto
     */
    newPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OwnUserPasswordUpdateDto
     */
    repeatNewPassword?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OwnUserPasswordUpdateDto
     */
    tenantId?: number | null;
}

/**
 * Check if a given object implements the OwnUserPasswordUpdateDto interface.
 */
export function instanceOfOwnUserPasswordUpdateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OwnUserPasswordUpdateDtoFromJSON(json: any): OwnUserPasswordUpdateDto {
    return OwnUserPasswordUpdateDtoFromJSONTyped(json, false);
}

export function OwnUserPasswordUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnUserPasswordUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
        'repeatNewPassword': !exists(json, 'repeatNewPassword') ? undefined : json['repeatNewPassword'],
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
    };
}

export function OwnUserPasswordUpdateDtoToJSON(value?: OwnUserPasswordUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'newPassword': value.newPassword,
        'repeatNewPassword': value.repeatNewPassword,
        'tenantId': value.tenantId,
    };
}

